export default {
  modal: false,
  gallery: false,
  moving: false,
  menu: false,
  logo: false,
}